"use client";

// npm packages
import { useRouter } from "next/navigation";
import { Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// swiper slider
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./custom_scrollbar.css";

// components
import Button from "../Button";
import Text from "../Text";

// utils

export const FeaturedJobSlider = ({ data = [] }) => {
  const router = useRouter();

  return (
    <div className="h-auto relative">
      <Swiper
        modules={[Scrollbar]}
        spaceBetween={10}
        slidesPerView={"auto"}
        // centeredSlides={true}
        // slidesOffsetBefore={500}
        // autoplay={{
        //   delay: 3000,
        //   disableOnInteraction: false,
        // }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          1024: {
            spaceBetween: 40,
          }
        }}
        scrollbar={{
          hide: false,
          draggable: true
        }}
        className="!pt-16 !pb-24 !px-8 featured-job-slider"
      >
        <>
          {data.length > 0 && data?.map((item, index) => {
            return (
              <SwiperSlide
                key={item?.id}
                className="w-full md:max-w-[386px] p-24 rounded-xl shadow-what-are-you-looking-for-box-shadow"
              >
                <Text
                  type="sub_title"
                  className="text-20 text-coarse-wool font-encode-sans font-semibold leading-28 tracking-[0.40px] line-clamp-2 mb-8"
                >
                  {item?.name}
                </Text>
                <Text
                  type="sub_title"
                  className="text-16 text-coarse-wool font-encode-sans font-medium leading-20 tracking-[0.32px] line-clamp-1 mb-12"
                >
                  {item?.location}
                </Text>
                <div className="flex gap-[8px] mb-24">
                  {item?.labels.map((item, index) => (
                    <Text
                      key={index}
                      type="span"
                      className="bg-aquarelle-purple !text-14 text-coarse-wool font-medium leading-20 tracking-[0.28px] line-clamp-1 px-10 py-4 rounded-[100px]"
                    >
                      {item}
                    </Text>
                  ))}
                </div>
                <Button
                  type="outline"
                  className="w-full max-w-[200px] lg:max-w-[220px] flex items-center justify-center !border-tealgreen mx-auto !px-16 !py-10"
                  onClick={() => router.push("/career/description")}
                >
                  <Text
                    type="paragraph"
                    className="text-14 text-tealgreen font-encode-sans font-bold leading-20 tracking-[0.28px] line-clamp-1"
                  >
                    Learn More
                  </Text>
                </Button>
              </SwiperSlide>
            );
          })};
        </>
      </Swiper>
    </div >
  );
};
